<div class="p-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "material.headers.product_asset_management" | translate }}
  </h2>

  <!-- Search Form -->
  <app-search-form
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (primaryButtonClick)="onAddMaterial()"
        (secondaryonClick)="onDeleteSelected()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <advanced-data-table
      #advancedTable
      [dataSource]="filteredMaterials()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="(currentPage() - 1) * pageSize()"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="canDelete()"
      [selection]="selectedMaterials()"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      class="w-full"
    >
      <!-- Custom template for main image, detail HTML, and date -->
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column && column.template === "dateTemplate") {
          <span class="text-xs text-gray-600">
            {{ formatDateTime(value) }}
          </span>
        } @else if (column && column.prop === "mainImage") {
          <div class="flex justify-center">
            @if (value?.previewUrl) {
              <div class="w-12 h-12 flex items-center justify-center">
                <img
                  [src]="value.previewUrl"
                  [alt]="value.materialName"
                  class="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
            } @else {
              <span class="text-gray-500 italic">{{
                "material.values.no_image" | translate
              }}</span>
            }
          </div>
        } @else if (column && column.prop === "detailHtml") {
          <div class="html-description-cell">
            @if (value && typeof value === "string" && value.trim()) {
              <div
                class="html-preview"
                [innerHTML]="value"
                [pTooltip]="stripHtmlTags(value)"
                tooltipPosition="bottom"
                tooltipStyleClass="html-tooltip"
                [showDelay]="500"
                [hideDelay]="100"
                [tooltipOptions]="{
                  showDelay: 500,
                  hideDelay: 100,
                  appendTo: 'body',
                }"
              ></div>
            } @else {
              <span class="text-gray-500 italic">{{
                "material.values.no_description" | translate
              }}</span>
            }
          </div>
        }
      </ng-template>

      <!-- Custom Status Template -->
      <ng-template #statusTemplate let-status>
        <div class="flex items-center justify-center gap-1">
          <p-tag
            [value]="getStatusDisplayText(status) | translate"
            [severity]="getStatusSeverity(status)"
            styleClass="status-tag"
            [ngStyle]="getStatusStyle(status)"
            [pTooltip]="
              status
                ? ('material.tooltips.active' | translate)
                : ('material.tooltips.inactive' | translate)
            "
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </div>
      </ng-template>

      <!-- Actions template -->
      <ng-template #actionsTemplate let-rowData>
        <div class="flex gap-2 justify-center">
          @if (canUpdate()) {
            <span
              (click)="onEditMaterial(rowData)"
              class="action-link action-edit cursor-pointer"
            >
              {{ "material.actions.edit" | translate }}
            </span>
          }
          @if (canDelete()) {
            <span
              (click)="onDeleteMaterial(rowData)"
              class="action-link action-delete cursor-pointer"
            >
              {{ "material.actions.delete" | translate }}
            </span>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast></p-toast>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle | translate"
  [message]="dialogMessage | translate"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
